import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";
import { useAppSelector } from "../app/hooks";
import { UserRole, isAdminRole } from "../app/userSlice";

export default function RequireCourseOrAdminSession() {
	const { course, school, district, role } = useAppSelector((state) => state.user);
	const navigate = useNavigate();

	const courseRequired = !isAdminRole(role);

	useEffect(() => {
		if (role === UserRole.SchoolAdmin && !school) {
			navigate("/selectSchool");
		}
		if (role === UserRole.DistrictAdmin && !district) {
			navigate("/selectDistrict");
		}

		// For non-admin users, require course selection
		if (!course && courseRequired && !isAdminRole(role)) {
			navigate("/courses");
		}
	});

	return <Outlet />;
}
